import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import {
  getIsChallengeQuest,
  getAreAllQuestsAndChallengesComplete,
  getCurrentQuestNumber,
} from 'a/hub/selectors/workshopSelectors';

import {
  DiamondProgress,
  ProgressDialogs,
  BigBrownPanel,
  TitleText,
  HeaderText,
} from '../sharedComponents';

const QuestStatus = ({ titleId, anyProgress, dialogs }) => {
  const questName = useSelector(getCurrentQuestNumber);
  const areAllQuestsAndChallengesComplete = useSelector(getAreAllQuestsAndChallengesComplete);
  const isChallengeQuest = useSelector(getIsChallengeQuest);

  const headerText = anyProgress ? 'Welcome Back!' : 'New Quest Unlocked';

  let modalTitleText;
  if (areAllQuestsAndChallengesComplete) {
    modalTitleText = 'UNLOCKED';
  } else if (isChallengeQuest) {
    modalTitleText = 'CHALLENGE';
  } else {
    modalTitleText = `QUEST ${questName}`;
  }

  return (
    <>
      <BigBrownPanel />
      <TitleText id={titleId} top={82} left={390} width={242}>
        {modalTitleText}
      </TitleText>
      <StyledHeaderText data-testid="login-modal-message">{headerText}</StyledHeaderText>
      {!isChallengeQuest ? (
        <DiamondProgress />
      ) : (
        <DiamondProgress portalProgress={1} radioProgress={1} bookProgress={1} batteryProgress={1} areAllComplete />
      )}
      <ProgressDialogs dialogs={dialogs} />
    </>
  );
};

QuestStatus.propTypes = {
  titleId: PropTypes.string.isRequired,
  anyProgress: PropTypes.bool,
  dialogs: PropTypes.array,
};

QuestStatus.defaultProps = {
  anyProgress: false,
  dialogs: [],
};

export default QuestStatus;

const StyledHeaderText = styled(HeaderText)`
  position: absolute;
  top: 179px;
  left: 476px;
  width: 305px;
`;
